import React from 'react';
import CertificationDetails from '../../../../components-legacy/CertificationDetails';
import Distance from '../../../../styled/Distance';
import { IProductCertification } from '../providers/useParseProduct';

interface ICertificationsProps {
  productCertifications: IProductCertification[];
}

const CertificationInformation = ({ productCertifications }: ICertificationsProps) => {
  return (
    <>
      <Distance size="2" />
      {productCertifications.map((certification, index) => (
        <React.Fragment key={index}>
          <CertificationDetails
            image={certification.image}
            title={certification.title}
            subtitle={certification.subtitle}
            description={certification.description}
            licensenumber={certification.licensenumber}
          />
          <Distance line size="3" />
        </React.Fragment>
      ))}
    </>
  );
};

export default CertificationInformation;
